module.exports = {"HorsSportGeorgia":"HORSE SPORT GEORGIA"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EN-vers/Header/headerSubTitleJSON/en-headerSubTitle.json
// module id = 0Cln
// module chunks = 0